import {Injectable} from '@angular/core';
import {RequestProvider} from "../request/request";

/*
  Generated class for the WorkReportProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WorkReportProvider {

  constructor(public request: RequestProvider) {
  }

  getMyWorkReportsForSaleOrder(name: any) {
    return new Promise((resolve, reject) => {
      this.request.get(`work.report/my/${name}`, true).subscribe(data => {
        if (data.count == 0) resolve([]);
        else resolve(data.results);
      }, err => {
        resolve([]);
      });
    });
  }

  create(salesOrder: any, date: any) {
    let data = {
      sale_id: salesOrder.id,
      date_work: date,
    };

    return new Promise((resolve, reject) => {
      this.request.post(`work.report/save`, data, true).subscribe(data => {
        resolve(data.name);
      }, err => {
        resolve(null);
      });
    });
  }

  get(workReportNumber: any) {
    return new Promise((resolve, reject) => {
      this.request.get(`work.report/${workReportNumber}`, true).subscribe(data => {
        resolve(data);
      }, err => {
        resolve([]);
      });
    });
  }

  delete(workReportNumber: any) {
    return new Promise((resolve, reject) => {
      this.request.get(`work.report/${workReportNumber}/delete`, true).subscribe(data => {
        resolve(data);
      }, err => {
        resolve([]);
      });
    });
  }

  save(workReport: any) {
    return new Promise((resolve, reject) => {
      this.request.post(`work.report/save`, workReport, true).subscribe(data => {
        resolve(data.name);
      }, err => {
        resolve("");
      });
    });
  }

  savePart(workReportName: any, part: any, images: any) {
    let data = {
      'images': images,
      'part': part
    };

    return new Promise((resolve, reject) => {
      this.request.post(`work.report/${workReportName}/part`, data, true).subscribe(data => {
        resolve(data.id);
      }, err => {
        resolve(0);
      });
    });
  }

  loadPart(id: any) {
    return new Promise((resolve, reject) => {
      this.request.get(`part.not.ok/${id}`, true).subscribe(data => {
        resolve(data);
      }, err => {
        resolve([]);
      });
    });
  }

  getImages(partId: any) {
    return new Promise((resolve, reject) => {
      this.request.get(`part-images/${partId}`, true).subscribe(data => {
        resolve(data);
      }, err => {
        resolve({});
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/work-report/work-report.ts